/**
 * Shared KPI tile chrome: each tile is a square. Title stays at the top;
 * actual, graph, and plan are one block vertically centered in the rest.
 */

import React from 'react';
import { TileHideButton } from './TileHideButton';
import { GAUGE_FILL } from './types';

interface KpiTileShellProps {
  name: string;
  children: React.ReactNode;
  hideLabel?: string;
  onHide?: () => void;
  color?: 'GREEN' | 'YELLOW' | 'RED' | null;
}

export const KpiTileShell: React.FC<KpiTileShellProps> = ({ name, children, hideLabel, onHide, color }) => (
  <article
    className="relative w-full aspect-square border border-[var(--color-border)] rounded p-1.5 bg-[var(--color-secondary-bg)] flex flex-col min-w-0 overflow-hidden"
    style={color ? { borderTopWidth: 3, borderTopColor: GAUGE_FILL[color] } : undefined}
  >
    {onHide && <TileHideButton label={hideLabel || 'Hide'} onHide={onHide} />}
    <h3
      className="text-center text-base font-bold text-[var(--color-surface-text)] leading-snug mt-2 mb-1 mx-1 line-clamp-2 shrink-0"
      title={name}
    >
      {name}
    </h3>
    <div className="flex-1 flex flex-col justify-center min-h-0">{children}</div>
  </article>
);
